import { Box, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PageContainer = styled(Grid)(() => ({
  padding: '47px 60px 60px 160px',
  backgroundColor: '#FAFCFF',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
}));

export const HeaderBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
}));

export const HeaderTopRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: '16px',
}));

export const TitleRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
  flexWrap: 'wrap',
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  color: theme.palette.text.secondary,
  marginTop: '8px',
  marginBottom: '4px',
}));

export const ChartsGrid = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))',
  gap: '16px',
}));

export const HintBanner = styled(Box)(() => ({
  padding: '8px 14px',
  borderRadius: '6px',
  backgroundColor: 'rgba(255, 244, 229, 0.95)',
  color: '#9A4F00',
  fontSize: '12px',
}));

export const StaleHint = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  padding: '4px 10px',
  borderRadius: '12px',
  fontSize: '11px',
  fontWeight: 600,
  color: theme.palette.text.secondary,
  backgroundColor: 'rgba(123, 63, 242, 0.08)',
  '& .dot': {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    animation: 'pulse 1.2s ease-in-out infinite',
  },
  '@keyframes pulse': {
    '0%, 100%': { opacity: 0.4 },
    '50%': { opacity: 1 },
  },
}));
